import MD5 from 'md5';
import API from '@/services';
import { UPLOAD_MESSAGE_TO_SAVE_TIME, FAKE_SESSION_ID } from './constants';
import initStore from '@/stores/init';

export function getMessageUploadKey(messages: string[]) {
  return MD5(`${Date.now()}${messages.join('')}`);
}

export const MessageUploadStatusMap: { [key: string]: Promise<void> } = {};

const MessageUploadResolveMap: { [key: string]: (value: void | PromiseLike<void>) => void } = {};

// 上传消息 用于记录历史消息
// 消息顺序发送 一个发送出去间隔300ms发另一个 不管上一个是成功失败
export default (() => {
  const messagesToUpload: any[] = []; // 待发送
  let isSending = false;

  function handleMessageToUpload() {
    const firstMessage = messagesToUpload[0];

    if (isSending || !firstMessage) {
      return;
    }

    messagesToUpload.shift();

    isSending = true;

    const key = firstMessage.key;
    delete firstMessage.key;

    (API as any)
      .uploadMessage(firstMessage)
      .then(() => {
        if (key) {
          MessageUploadResolveMap[key]?.();
        }
      })
      .catch(() => {
        if (key) {
          MessageUploadResolveMap[key]?.();
        }
      });

    setTimeout(() => {
      isSending = false;
      handleMessageToUpload();
    }, UPLOAD_MESSAGE_TO_SAVE_TIME);
  }

  return (data: any) => {
    const { sessionId, dialogueId, messages, key } = data;
    const params: any = {
      session_id: sessionId || initStore.sessionId,
      dialogue_id: dialogueId,
      messages,
    };

    if (!params.session_id || params.session_id === FAKE_SESSION_ID) {
      return;
    }

    if (key) {
      params.key = key;
      MessageUploadStatusMap[key] = new Promise((resolve) => {
        MessageUploadResolveMap[key] = resolve;
      });
    }

    messagesToUpload.push(params);

    handleMessageToUpload();
  };
})();

